import axios, { AxiosInstance } from 'axios';

const ENDPOINT = process.env.NEXT_PUBLIC_ENDPOINT;

export const axiosRequest = (accessToken?: string, headers = {}): AxiosInstance => {
    const initHeaders = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    };

    if (accessToken) {
        initHeaders['Authorization'] = `Bearer ${accessToken}`;
    }

    const axiosReq = axios.create({
        baseURL: ENDPOINT,
        headers: { ...initHeaders, ...headers },
    });
    if (axiosReq !== undefined) {
        axiosReq.interceptors.response.use((response) => {
            return response;
        }, async (error) => {
            const originalConfig = error.config;
            if (error.response) {
                if (error.response.status === 403 && !originalConfig._retry) {
                    originalConfig._retry = true;
                    const keycloak = (await import('~/src/services/auth')).default;
                    await keycloak.updateToken(30);
                    const { token } = keycloak;
                    axiosReq.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    return axiosReq(originalConfig);
                }
            }
            return Promise.reject(error);
        });
    }
    return axiosReq;
};
